import { NavLink, Outlet, useLocation } from 'react-router-dom';

interface GuardianTab {
  to: string;
  label: string;
  Icon: () => JSX.Element;
  end?: boolean;
  also?: string;
}

const TABS: ReadonlyArray<GuardianTab> = [
  // An educando's own page belongs to this tab too.
  { to: '/', label: 'Educandos', Icon: PeopleIcon, end: true, also: '/educandos/' },
  { to: '/conta', label: 'Conta', Icon: UserIcon },
];

/**
 * The PWA as an Encarregado de Educação sees it: their educandos and their
 * account. None of a Digger's tabs (reservations, scanning) are here.
 */
export default function GuardianLayout() {
  const { pathname } = useLocation();
  return (
    <div className="relative min-h-screen bg-background pb-28">
      <a href="#main-content" className="skip-link">
        Saltar para o conteúdo principal
      </a>

      <main id="main-content" className="safe-area-inset px-4 py-4">
        <Outlet />
      </main>

      <nav className="nav-shell" aria-label="Navegação principal">
        {TABS.map(({ to, label, Icon, end, also }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `nav-item ${isActive || (also && pathname.startsWith(also)) ? 'nav-item--active' : ''}`
            }
          >
            {({ isActive }) => (
              <>
                <Icon />
                <span
                  className="nav-label"
                  aria-current={isActive || (also && pathname.startsWith(also)) ? 'page' : undefined}
                >
                  {label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}

function PeopleIcon() {
  return (
    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="9" cy="8" r="3.5" />
      <path d="M2.5 20a6.5 6.5 0 0113 0" />
      <circle cx="17.5" cy="9.5" r="2.5" />
      <path d="M16 14.2a5 5 0 016.5 4.8" />
    </svg>
  );
}

function UserIcon() {
  return (
    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21a8 8 0 0116 0" />
    </svg>
  );
}
